(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["original-art-gallery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const galleries = document.querySelectorAll('.original-gallery');

    galleries.forEach((gallery) => {
      const filters = gallery.querySelectorAll('[data-gallery-filter]');
      const items = gallery.querySelectorAll('[data-gallery-item]');
      const status = gallery.querySelector('[data-gallery-status]');
      const empty = gallery.querySelector('[data-gallery-empty]');

      filters.forEach((filter) => {
        filter.addEventListener('click', () => {
          const selected = filter.dataset.galleryFilter;
          let visibleCount = 0;

          filters.forEach((button) => {
            const active = button === filter;
            button.classList.toggle('is-active', active);
            button.setAttribute('aria-pressed', String(active));
          });

          items.forEach((item) => {
            const visible = selected === 'all' || item.dataset.galleryStatus === selected;
            item.hidden = !visible;
            if (visible) visibleCount += 1;
          });

          empty.hidden = visibleCount !== 0;
          status.textContent = `${visibleCount} ${gallery.dataset.countSuffix}`;
        });
      });

      gallery.querySelectorAll('[data-context-toggle]').forEach((toggle) => {
        toggle.addEventListener('click', () => {
          const card = toggle.closest('.gallery-art-card');
          const active = !card.classList.contains('is-context-visible');
          card.classList.toggle('is-context-visible', active);
          toggle.setAttribute('aria-pressed', String(active));
          toggle.textContent = active ? toggle.dataset.hideLabel : toggle.dataset.showLabel;
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tattoo-project-game"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const TALLY_SCRIPT_URL = 'https://tally.so/widgets/embed.js';
    const safeParse = (value, fallback) => {
      try { return JSON.parse(value) || fallback; } catch (error) { return fallback; }
    };
    const readStorage = (key) => {
      try { return safeParse(window.localStorage.getItem(key), {}); } catch (error) { return {}; }
    };
    const writeStorage = (key, value) => {
      try { window.localStorage.setItem(key, JSON.stringify(value)); } catch (error) { /* Storage can be unavailable. */ }
    };
    const clearStorage = (key) => {
      try { window.localStorage.removeItem(key); } catch (error) { /* Storage can be unavailable. */ }
    };
    const trimValue = (value, maxLength) => String(value || '').trim().slice(0, maxLength);
    const sendEvent = (name, params = {}) => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name, ...params });
    };
    const ensureTallyLibrary = () => {
      if (window.Tally?.loadEmbeds) return Promise.resolve(window.Tally);
      if (window.__joannartattooTallyPromise) return window.__joannartattooTallyPromise;

      window.__joannartattooTallyPromise = new Promise((resolve, reject) => {
        let settled = false;
        let script = document.querySelector(`script[src="${TALLY_SCRIPT_URL}"]`);
        let shouldAppend = false;
        const finish = () => {
          if (settled) return;
          settled = true;
          if (window.Tally?.loadEmbeds) resolve(window.Tally);
          else {
            if (script) script.dataset.tallyLoadFailed = 'true';
            reject(new Error('Tally unavailable'));
          }
        };
        const fail = () => {
          if (script) script.dataset.tallyLoadFailed = 'true';
          finish();
        };

        if (!script || script.dataset.tallyLoadFailed === 'true') {
          script?.remove();
          script = document.createElement('script');
          script.src = TALLY_SCRIPT_URL;
          script.async = true;
          shouldAppend = true;
        }

        script.addEventListener('load', finish, { once: true });
        script.addEventListener('error', fail, { once: true });
        if (shouldAppend) document.body.appendChild(script);
        window.setTimeout(finish, 12000);
      }).catch((error) => {
        window.__joannartattooTallyPromise = null;
        throw error;
      });

      return window.__joannartattooTallyPromise;
    };

    document.querySelectorAll('[data-tattoo-game]').forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      const form = root.querySelector('.tattoo-game__form');
      const steps = [...root.querySelectorAll('[data-step]')];
      const labels = safeParse(root.querySelector('[data-summary-labels]').textContent, {});
      const storageKey = root.dataset.storageKey;
      const saved = readStorage(storageKey);
      const state = { ...saved, current: 1, started: false };
      const contact = {};
      const back = root.querySelector('[data-back]');
      const next = root.querySelector('[data-next]');
      const navigation = root.querySelector('.tattoo-game__navigation');
      const errorBox = root.querySelector('[data-error]');
      const guide = root.querySelector('[data-guide]');
      const progressText = root.querySelector('[data-progress-text]');
      const progressPercent = root.querySelector('[data-progress-percent]');
      const progressBar = root.querySelector('[data-progress-bar]');
      const ink = [...root.querySelectorAll('[data-ink]')];
      const inkMachine = root.querySelector('[data-ink-machine]');
      const tallyWrap = root.querySelector('[data-tally-wrap]');
      const tallyMount = root.querySelector('[data-tally-mount]');
      const submitError = root.querySelector('[data-submit-error]');
      const success = root.querySelector('[data-success]');
      const persistentFields = ['idea', 'likes', 'avoid', 'availability'];
      const trackedEvents = new Set();
      let submissionHandled = false;
      let tallyLoadTimer = 0;
      let machineTimer = 0;
      let previousProgressStep = 0;

      const persist = () => {
        const clean = {};
        ['style','idea','emotions','palette','placement','size','likes','avoid','budget','timing','availability'].forEach((key) => {
          if (state[key]) clean[key] = state[key];
        });
        writeStorage(storageKey, clean);
      };
      const trackOnce = (name, params = {}) => {
        if (trackedEvents.has(name)) return;
        trackedEvents.add(name);
        sendEvent(name, params);
      };
      const start = () => {
        if (state.started) return;
        state.started = true;
        sendEvent('tattoo_game_start');
      };
      const syncPersistentFields = () => {
        persistentFields.forEach((key) => {
          const field = root.querySelector(`[data-field="${key}"]`);
          if (field) state[key] = field.value.trim();
        });
      };
      const syncContact = () => {
        root.querySelectorAll('[data-contact]').forEach((field) => {
          contact[field.dataset.contact] = field.type === 'checkbox' ? field.checked : field.value.trim();
        });
      };
      const updateProgress = () => {
        const progressStep = Math.min(state.current, 8);
        const percent = Math.round((progressStep / 8) * 100);
        progressText.textContent = (labels.step_template || 'Étape __CURRENT__ sur 8').replace('__CURRENT__', progressStep);
        progressPercent.textContent = `${percent}%`;
        progressBar.style.width = `${percent}%`;
        const stepChanged = progressStep !== previousProgressStep;
        if (inkMachine) {
          inkMachine.style.left = `${((progressStep - .5) / 8) * 100}%`;
          if (stepChanged) {
            window.clearTimeout(machineTimer);
            inkMachine.classList.remove('is-inking');
            void inkMachine.offsetWidth;
            inkMachine.classList.add('is-inking');
            machineTimer = window.setTimeout(() => inkMachine.classList.remove('is-inking'), 760);
          }
        }
        ink.forEach((drop, index) => {
          drop.classList.toggle('is-filled', index < progressStep);
          drop.classList.toggle('is-active', index === progressStep - 1);
          if (index === progressStep - 1) drop.setAttribute('aria-current', 'step');
          else drop.removeAttribute('aria-current');
        });
        previousProgressStep = progressStep;
      };
      const showStep = (number, options = {}) => {
        state.current = Math.max(1, Math.min(9, number));
        steps.forEach((step) => { step.hidden = Number(step.dataset.step) !== state.current; });
        const active = steps.find((step) => Number(step.dataset.step) === state.current);
        if (active) guide.textContent = active.dataset.guide || '';
        back.hidden = state.current === 1;
        next.hidden = state.current === 9;
        errorBox.hidden = true;
        updateProgress();
        const heading = active?.querySelector('h2');
        if (heading && options.focus !== false) {
          heading.setAttribute('tabindex', '-1');
          heading.focus({ preventScroll: true });
        }
        if (options.scroll !== false) {
          root.querySelector('.tattoo-game__panel').scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        if (state.current === 9) window.setTimeout(loadTally, 0);
      };
      const setChoice = (button) => {
        start();
        const key = button.dataset.choice;
        const group = button.closest('[data-choice-group]');
        const multiple = group.dataset.multiple === 'true';
        if (multiple) {
          const values = new Set(Array.isArray(state[key]) ? state[key] : []);
          if (values.has(button.dataset.value)) values.delete(button.dataset.value); else values.add(button.dataset.value);
          state[key] = [...values];
          button.setAttribute('aria-pressed', String(values.has(button.dataset.value)));
        } else {
          state[key] = button.dataset.value;
          group.querySelectorAll('[data-choice]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        }
        persist();
      };
      const validStep = () => {
        const rules = {
          1: () => Boolean(state.style),
          2: () => Boolean((state.idea || '').trim()),
          3: () => Boolean(state.palette),
          4: () => Boolean(state.placement),
          5: () => Boolean(state.size),
          6: () => true,
          7: () => Boolean(state.budget && state.timing),
          8: () => {
            const emailInput = root.querySelector('[data-contact="email"]');
            const phoneInput = root.querySelector('[data-contact="phone"]');
            const cityInput = root.querySelector('[data-contact="city"]');
            return Boolean(
              contact.name &&
              contact.phone &&
              contact.city &&
              emailInput.checkValidity() &&
              phoneInput.checkValidity() &&
              cityInput.checkValidity() &&
              contact.consent
            );
          }
        };
        return rules[state.current] ? rules[state.current]() : true;
      };
      const valueText = (value) => Array.isArray(value) ? value.join(', ') : (value || labels.empty || '—');
      const summaryEntries = () => [
        ['style', state.style], ['idea', state.idea], ['emotions', state.emotions], ['palette', state.palette],
        ['placement', state.placement], ['size', state.size], ['likes', state.likes], ['avoid', state.avoid],
        ['budget', state.budget], ['timing', state.timing], ['availability', state.availability],
        ['name', contact.name], ['email', contact.email], ['phone', contact.phone], ['city', contact.city]
      ];
      const summaryText = () => summaryEntries().map(([key, value]) => `${labels[key] || key} : ${valueText(value)}`).join('\n');
      const buildSummary = () => {
        const summary = root.querySelector('[data-summary]');
        summary.textContent = '';
        summaryEntries().forEach(([key, value]) => {
          const item = document.createElement('dl');
          item.className = 'tattoo-game__summary-item';
          const term = document.createElement('dt');
          const description = document.createElement('dd');
          term.textContent = labels[key] || key;
          description.textContent = valueText(value);
          item.append(term, description);
          summary.append(item);
        });
      };
      const phoneForTally = () => {
        const rawPhone = (contact.phone || '').trim();
        const digits = rawPhone.replace(/\D/g, '');
        if (digits.length === 10) return `+1${digits}`;
        if (digits.length === 11 && digits.startsWith('1')) return `+${digits}`;
        return rawPhone;
      };
      const buildHiddenFields = () => {
        const pageParams = new URLSearchParams(window.location.search);
        const notes = [
          state.likes ? `${labels.likes || 'Inspirations'} : ${state.likes}` : '',
          state.avoid ? `${labels.avoid || 'À éviter'} : ${state.avoid}` : ''
        ].filter(Boolean).join('\n');

        return {
          nom: trimValue(contact.name, 120),
          email: trimValue(contact.email, 180),
          telephone: trimValue(phoneForTally(), 32),
          ville: trimValue(contact.city, 120),
          style: trimValue(state.style, 140),
          intention: trimValue(valueText(state.emotions), 320),
          sujet: trimValue(state.idea, 650),
          elements_secondaires: '',
          palette: trimValue(state.palette, 140),
          emplacement: trimValue(state.placement, 140),
          dimension: trimValue(state.size, 140),
          budget: trimValue(state.budget, 140),
          echeance: trimValue(state.timing, 180),
          disponibilites: trimValue(state.availability, 320),
          notes: trimValue(notes, 650),
          consentement: contact.consent ? 'oui' : 'non',
          resume_projet: trimValue(summaryText(), 2600),
          langue: trimValue(document.documentElement.lang || 'fr', 12),
          source_page: trimValue(window.location.pathname, 240),
          utm_source: trimValue(pageParams.get('utm_source'), 180),
          utm_medium: trimValue(pageParams.get('utm_medium'), 180),
          utm_campaign: trimValue(pageParams.get('utm_campaign'), 180),
          version_jeu: trimValue(root.dataset.gameVersion, 48)
        };
      };
      const buildTallyUrl = () => {
        const formId = trimValue(root.dataset.tallyId, 64);
        if (!/^[A-Za-z0-9_-]{4,64}$/.test(formId)) return '';
        const params = new URLSearchParams({
          alignLeft: '1',
          transparentBackground: '1',
          dynamicHeight: '1',
          hideTitle: '1'
        });
        Object.entries(buildHiddenFields()).forEach(([key, value]) => params.set(key, value));
        return `https://tally.so/embed/${encodeURIComponent(formId)}?${params.toString()}`;
      };
      const showSubmitError = () => {
        window.clearTimeout(tallyLoadTimer);
        tallyWrap.hidden = true;
        submitError.hidden = false;
        submitError.focus?.({ preventScroll: true });
      };
      const loadTally = () => {
        if (submissionHandled) return;
        const embedUrl = buildTallyUrl();
        if (!embedUrl) {
          showSubmitError();
          return;
        }

        window.clearTimeout(tallyLoadTimer);
        submitError.hidden = true;
        tallyWrap.hidden = false;
        tallyMount.textContent = '';

        const frame = document.createElement('iframe');
        frame.dataset.tallySrc = embedUrl;
        frame.loading = 'lazy';
        frame.width = '100%';
        frame.height = '340';
        frame.frameBorder = '0';
        frame.marginHeight = '0';
        frame.marginWidth = '0';
        frame.title = labels.tally_title || 'Ajoute tes images d’inspiration';
        tallyMount.append(frame);

        ensureTallyLibrary().then((tally) => {
          tally.loadEmbeds();
          tallyLoadTimer = window.setTimeout(showSubmitError, 15000);
        }).catch(showSubmitError);
        trackOnce('tattoo_game_open_form');
      };
      const handleSubmission = () => {
        if (submissionHandled) return;
        submissionHandled = true;
        window.clearTimeout(tallyLoadTimer);

        const firstName = trimValue(contact.name, 120).split(/\s+/)[0];
        const successTitle = labels.success_title || 'Merci, __NAME__!';
        const renderedTitle = successTitle.replace('__NAME__', firstName);
        const successHeading = success.querySelector('[data-success-title]');
        successHeading.textContent = renderedTitle;

        clearStorage(storageKey);
        form.reset();
        root.querySelectorAll('[data-choice]').forEach((button) => button.setAttribute('aria-pressed', 'false'));
        Object.keys(state).forEach((key) => delete state[key]);
        Object.keys(contact).forEach((key) => delete contact[key]);

        const reveal = root.querySelector('[data-step="9"]');
        [...reveal.children].forEach((child) => { child.hidden = child !== success; });
        navigation.hidden = true;
        success.hidden = false;
        success.focus({ preventScroll: true });

        trackOnce('generate_lead', { lead_source: 'tattoo_project_game' });
        trackOnce('tattoo_game_submit', { game_version: root.dataset.gameVersion || '2.0' });
      };

      form.addEventListener('submit', (event) => event.preventDefault());
      root.addEventListener('click', (event) => {
        const choice = event.target.closest('[data-choice]');
        if (choice) setChoice(choice);
        if (event.target.closest('[data-back]')) showStep(state.current - 1);
        if (event.target.closest('[data-next]')) {
          start();
          syncPersistentFields();
          syncContact();
          persist();
          if (!validStep()) {
            errorBox.hidden = false;
            errorBox.setAttribute('tabindex', '-1');
            errorBox.focus();
            return;
          }
          sendEvent('tattoo_game_step_complete', { step_number: state.current });
          if (state.current === 8) { buildSummary(); sendEvent('tattoo_game_reveal'); showStep(9); }
          else showStep(state.current + 1);
        }
        if (event.target.closest('[data-retry-tally]')) loadTally();
      });
      root.addEventListener('input', (event) => {
        if (event.target.matches('[data-field]')) { state[event.target.dataset.field] = event.target.value; persist(); }
        if (event.target.matches('[data-contact]')) {
          const key = event.target.dataset.contact;
          contact[key] = event.target.type === 'checkbox' ? event.target.checked : event.target.value.trim();
        }
      });
      window.addEventListener('message', (event) => {
        if (event.origin !== 'https://tally.so') return;
        const message = typeof event.data === 'string' ? safeParse(event.data, null) : event.data;
        if (!message || message.payload?.formId !== root.dataset.tallyId) return;
        if (message.event === 'Tally.FormLoaded') {
          window.clearTimeout(tallyLoadTimer);
          submitError.hidden = true;
          tallyWrap.hidden = false;
        }
        if (message.event === 'Tally.FormSubmitted') handleSubmission();
      });

      persistentFields.forEach((key) => { const field = root.querySelector(`[data-field="${key}"]`); if (field && state[key]) field.value = state[key]; });
      root.querySelectorAll('[data-choice]').forEach((button) => {
        const selected = Array.isArray(state[button.dataset.choice]) ? state[button.dataset.choice].includes(button.dataset.value) : state[button.dataset.choice] === button.dataset.value;
        button.setAttribute('aria-pressed', String(selected));
      });
      showStep(1, { focus: false, scroll: false });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
